export const getStatusThings = {
  thingsTypes: ['VAC001', 'PUR001'],
  endPoint: 'getStatus',
};

export const getCookingStatusThings = {
  thingsTypes: ['COO001', 'COO002', 'COM001', 'KMC001', 'MUL001'],
  endPoint: 'getCookingStatus',
};
